<template>
  <section class="flex flex-col gap-4 p-4 md:p-6">
    <TextTitle>Marktresultaten</TextTitle>

    <div class="h-72">
      <LoadingWrapper :error="isQuarter && quarterFailed">
        <template #error>
          <p class="text-sm text-gray-600">
            De kwartierdata kon niet worden opgehaald. Probeer het later
            opnieuw.
          </p>
          <button
            type="button"
            class="bg-primary hover:bg-primary-600 mt-3 rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors"
            @click="$emit('retry')"
          >
            Opnieuw proberen
          </button>
        </template>
        <div v-if="hasChartData" class="cls_static-legend h-full">
          <TimeseriesChart
            :chart-type="chartType"
            :series="chartSeries"
            :axes="chartAxes"
            :data="chartData"
            :x-limits="chartLimits"
            :time-unit="chartTimeUnit"
          />
        </div>
        <output
          v-else
          class="flex h-full items-center justify-center rounded-lg bg-gray-50 text-gray-400 italic"
        >
          {{ isLoading ? "Gegevens ophalen..." : "Geen data beschikbaar" }}
        </output>
      </LoadingWrapper>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue"
import { GRANULARITY } from "@/helpers/energyBillConstants.js"
import {
  TextTitle,
  TimeseriesChart,
  LoadingWrapper,
} from "@repowerednl/ui-component-library"

const props = defineProps({
  granularity: { type: String, required: true },
  chartType: { type: String, required: true },
  chartSeries: { type: Object, required: true },
  chartAxes: { type: Object, required: true },
  chartData: { type: Object, required: true },
  chartLimits: { type: Array, required: true },
  chartTimeUnit: { type: String, required: true },
  loadingQuarter: { type: Boolean, default: false },
  quarterFailed: { type: Boolean, default: false },
})

defineEmits(["retry"])

const isQuarter = computed(() => props.granularity === GRANULARITY.QUARTER)

const isLoading = computed(() => isQuarter.value && props.loadingQuarter)

const hasChartData = computed(
  () => props.chartData && Object.keys(props.chartData).length > 0,
)
</script>

<style scoped>
/*
 * Clicking a legend item hides that series in the chart library, and there is
 * no prop to switch that off. The market results should always be visible, so
 * the legend items are made non-interactive here. This also drops their pointer
 * cursor and hover highlight, so they no longer look clickable.
 */
.cls_static-legend :deep(li) {
  pointer-events: none;
}
</style>
